import * as React from 'react';

import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import {
  $canAddScaleToFavorite,
  $currentScale,
  $displayedScales,
  $favoriteScaleIds,
  $favoriteScales,
  $labeledScales,
  $scaleId,
  $scalesError,
  $scalesLoading,
  $showScaleCamera,
  maxFavoriteScales,
} from '../_state/scales.state';

export const useScales = () => {
  const loading = useAtomValue($scalesLoading);
  const error = useAtomValue($scalesError);
  const allScales = useAtomValue($labeledScales);
  const favoriteScales = useAtomValue($favoriteScales);
  const displayedScales = useAtomValue($displayedScales);
  const currentScale = useAtomValue($currentScale);
  const canAddScaleToFavorite = useAtomValue($canAddScaleToFavorite);
  const showScaleCamera = useAtomValue($showScaleCamera);

  const setCurrentScaleId = useSetAtom($scaleId);
  const setShowScaleCamera = useSetAtom($showScaleCamera);

  const [favoriteScaleIds, setFavoriteScaleIds] = useAtom($favoriteScaleIds);

  const addScaleToFavorite = React.useCallback(
    (scaleId: string) => {
      setFavoriteScaleIds([...favoriteScaleIds, scaleId]);
    },
    [favoriteScaleIds, setFavoriteScaleIds],
  );

  const removeScaleFromFavorite = React.useCallback(
    (scaleId: string) => {
      setFavoriteScaleIds(
        favoriteScaleIds.filter(
          (favoriteScaleId) => favoriteScaleId !== scaleId,
        ),
      );
    },
    [favoriteScaleIds, setFavoriteScaleIds],
  );

  return {
    loading,
    error,
    allScales,
    favoriteScales,
    displayedScales,
    currentScale,
    setCurrentScaleId,
    addScaleToFavorite,
    removeScaleFromFavorite,
    canAddScaleToFavorite,
    maxFavoriteScales,
    showScaleCamera,
    setShowScaleCamera,
  };
};
